import { formatLogDate } from "@/lib/dates";
import type { RecipeLog } from "./types";

interface RecipeLogListProps {
    readonly logs: readonly RecipeLog[];
}

/**
 * The cook-log rows: date on the left, note (if any) on the right, newest first.
 * Shared by the recipe-page section and the manage-table "View log" modal so
 * both render identically.
 */
export const RecipeLogList = ({ logs }: RecipeLogListProps) => {
    if (logs.length === 0) return null;

    return (
        <ul className="divide-y divide-[var(--hairline)] border-t border-b border-[var(--hairline)]">
            {logs.map((log) => (
                <li key={log.id} className="flex flex-col gap-0.5 py-3.5 sm:flex-row sm:items-baseline sm:gap-6">
                    <span className="font-display text-[11px] uppercase tracking-[0.14em] text-primary-700 sm:w-28 sm:shrink-0">
                        {formatLogDate(log.madeOn)}
                    </span>
                    <span className="font-serif text-[15px] leading-6 text-[var(--fg-2)] sm:flex-1">
                        {log.note || <span className="text-[var(--fg-muted)]">—</span>}
                    </span>
                </li>
            ))}
        </ul>
    );
};
